export default __webpack_public_path__ + "static/media/top_2880.07a6c60b.webp";